import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { editorError } from "./api/use-editor";

export function DoorUpload({
  disabled,
  pending,
  dirty,
  onUpload,
}: {
  disabled: boolean;
  pending: boolean;
  dirty: boolean;
  onUpload: (file: File) => Promise<void>;
}) {
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState("");
  const [inputKey, setInputKey] = useState(0);
  return (
    <form
      className="editor-door-upload"
      onSubmit={async (event) => {
        event.preventDefault();
        if (!file || disabled) return;
        setError("");
        try {
          await onUpload(file);
          setFile(null);
          setInputKey((key) => key + 1);
        } catch (caught) {
          setError(editorError(caught));
        }
      }}
    >
      <p>1. Choose a file from your device.</p>
      <label>
        New door image
        <input
          key={inputKey}
          type="file"
          accept="image/png,image/jpeg,image/webp"
          disabled={disabled}
          onChange={(event) => {
            const next = event.target.files?.[0] ?? null;
            if (
              next &&
              (!["image/png", "image/jpeg", "image/webp"].includes(next.type) ||
                next.size > 10 * 1024 * 1024 ||
                next.size === 0)
            ) {
              setFile(null);
              setError("Choose a PNG, JPEG or WebP image up to 10 MiB.");
              return;
            }
            setFile(next);
            setError("");
          }}
        />
      </label>
      <p>
        Uploads save immediately for every difficulty sharing this door’s name.
        PNG, JPEG or WebP; up to 10 MiB and 16 megapixels.
      </p>
      {dirty && <p>Save or discard your text changes before uploading.</p>}
      {error && <p role="alert">{error}</p>}
      <p>2. Upload and save the selected image.</p>
      <Button type="submit" disabled={!file || disabled}>
        {pending ? "Uploading…" : "Upload and save door image"}
      </Button>
    </form>
  );
}
